import { useNavigate } from "react-router-dom";
import { Box, Tooltip } from "@mui/joy";
import { PlayArrowIcon } from "../../../styles/StyledMUI";
import { useConfirmationModal } from "../../../contexts/app/confirmation";
import TheoryTestHistory from "../../theorytest/TheoryTestHistory";
import type { TheoryTest } from "../../../api/theoryTests/TheoryTest.typed";
import IconButtonCTA from "../../common/IconButtonCTA";
import { roundActionIconButtonSx } from "../../../styles/globalStyles";

interface TrainingTestProps {
  trainingTemplateId?: number;
  theoryTests?: TheoryTest[];
}

export default function TrainingTest({ trainingTemplateId, theoryTests = [] }: TrainingTestProps) {
  const navigate = useNavigate();
  const { showConfirmation } = useConfirmationModal();

  const handleStartTheoryTest = async () => {
    const confirmed = await showConfirmation(
      "QCM",
      "Pour valider le test, vous devez obtenir un score minimum de 80%. Êtes-vous prêt à commencer ?",
    );

    if (confirmed && trainingTemplateId && trainingTemplateId > 0) {
      void navigate(`/portal/theory-test/${trainingTemplateId}`);
    }
  };

  return (
    <Box sx={{ padding: 1, textAlign: "center" }}>
      <Box sx={{ margin: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title="Commencer le test">
            <IconButtonCTA
              onClick={handleStartTheoryTest}
              size="lg"
              ctaVariant="accent"
              aria-label="Commencer le test"
              sx={{
                ...roundActionIconButtonSx,
                margin: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PlayArrowIcon />
            </IconButtonCTA>
          </Tooltip>
        </Box>

        {theoryTests.length > 0 && (
          <TheoryTestHistory tests={theoryTests} trainingTemplateId={trainingTemplateId} />
        )}
      </Box>
    </Box>
  );
}
